import { Component, Input, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { UserService } from "../../../../shared";
import { ClassAttendanceRequestModel } from "../ClassAttendanceRequestModel";
import { DataService_ClassroomAdmin } from "../shared/data.service";
import { StudentAttendanceInfo } from "../StudentAttendanceInfo";
import * as moment from "moment";

@Component({
	selector: "caass-class-attendance-menu",
	templateUrl: "./class-attendance-menu.component.html",
	styleUrls: ["./class-attendance-menu.component.css"],
})
export class ClassAttendanceMenuComponent implements OnInit {
	constructor(private userService: UserService, private classAdminService: DataService_ClassroomAdmin, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.LoadStatusList();

		//Let user use hotkeys for each attendance status
		document.addEventListener("keydown", (event) => {
			this.CheckKey(event);
		});

		//If SectionScheduleDetailID != -1, load data
		if (this.SectionScheduleDetailID != -1) {
			this.SchoolClosed = false;

			//this.LoadClassAttendance();
			this.LoadSchoolStatus();
			this.LoadExcuses();
		} else {
			this.lstClassAttendance = [];
			this.SchoolClosed = false;
		}
	}

	CheckKey(e) {
		if (String(e.key) == "Enter") {
			if (this.SelectedClassAttendance != undefined) {
				var index = 0;

				//Get index in table
				for (var i = 0; i < this.lstClassAttendance.length; i++) {
					var next = this.lstClassAttendance[i];

					if (next.PersonID == this.SelectedClassAttendance.PersonID) {
						index = i;
						break;
					}
				}

				this.SelectedClassAttendance = null;

				//If not the last, increment
				if (index < this.lstClassAttendance.length - 1) {
					this.SelectedClassAttendance = this.lstClassAttendance[index + 1];
					return;
				} else {
					if (this.Mode == "Add") {
						this.onAdd();
					} else {
						this.onUpdate();
					}
				}
			}

			return;
		}

		//Try picking the class attendance status with
		//the same code/hot key
		if (this.SelectedClassAttendance != null) {
			for (var i = 0; i < this.AttendanceStatusList.length; i++) {
				var next = this.AttendanceStatusList[i];

				if (String(next.ClassAttendanceStatusCD).toLowerCase() == String(e.key).toLowerCase()) {
					this.SelectedClassAttendance.ClassStatusID = next.ClassAttendanceStatusID;

					if (next.IsExcusedInd == 0 || String(next.ClassAttendanceStatusDesc).toLowerCase().indexOf("present") != -1) {
						this.SelectedClassAttendance.ExcuseID = -1;
					}

					return;
				}
			}
		}
	}

	//Update when Section ID changes
	ngOnChanges() {
		if (this.SectionScheduleDetailID != -1) {
			// this.LoadClassAttendance();
			this.LoadSchoolStatus();
			this.LoadExcuses();
		} else {
			this.lstClassAttendance = [];
		}
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	@Input() SectionScheduleDetailID: any = -1;
	@Input() SelectDate: any = new Date();
	@Input() SchoolID: any = -1;

	SchoolStatus: any = "Closed";

	//Dropdowns on table
	AttendanceStatusList: any = [];
	ExcuseList: any = [];

	Mode: any = "Add";

	SchoolClosed: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedClassAttendance: any;
	lstClassAttendance: any = [];

	//Filter lists
	lstClassStatusDesc: any = [];
	lstExcuseDesc: any = [];
	lstSchoolStatusDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'ClassStatusDesc', header: 'Class Status' },
		// { field: 'ExcuseDesc', header: 'Excuse' },
		// { field: 'SchoolStatusDesc', header: 'School Status' },
		{ field: "StudentID", header: "Student ID" },
		{ field: "LastName", header: "Last Name" },
		{ field: "FirstName", header: "First Name" },
	];

	///////////////

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////
	LoadStatusList() {
		var result = this.classAdminService.LoadStatusList();
		result.subscribe(
			(response) => {
				this.AttendanceStatusList = response;

				this.AttendanceStatusList.unshift({
					ClassAttendanceStatusID: -1,
					ClassAttendanceStatusCD: " ",
					ClassAttendanceStatusDesc: "<Select a Status>",
					IsExcuseInd: 0,
				});
			},
			(error) => {}
		);
	}

	LoadExcuses() {
		var result = this.classAdminService.LoadExcuses(this.SchoolID);
		result.subscribe(
			(response) => {
				this.ExcuseList = response;

				this.ExcuseList.unshift({
					ExcuseID: -1,
					ExcuseDesc: "<Excuse Reason Required>",
				});
			},
			(error) => {}
		);
	}

	LoadClassAttendance() {
		this.loading = true;
		// DateTime EntryDate,
		// int MissingSections,
		// int CourseID,
		// int PeriodID,
		// int InstructorPersonID,
		// int SchoolID

		var fDate = moment(new Date(this.SelectDate)).format("MM/DD/YYYY");

		var result = this.classAdminService.LoadSectionStudents(this.SectionScheduleDetailID, fDate);
		result.subscribe(
			(response) => {
				this.lstClassAttendance = response;

				//Load Data Filter Lists
				// this.lstClassStatusDesc = Array.from(new Set(this.lstClassAttendance.map((item: any) => item.ClassStatusDesc)));
				// this.lstExcuseDesc = Array.from(new Set(this.lstClassAttendance.map((item: any) => item.ExcuseDesc)));
				// this.lstSchoolStatusDesc = Array.from(new Set(this.lstClassAttendance.map((item: any) => item.SchoolStatusDesc)));

				this.Mode = "Add";
				if (this.lstClassAttendance.length > 0) {
					this.Mode = this.lstClassAttendance[0].ClassStatusID == -1 ? "Add" : "Update";
				}

				for (var i = 0; i < this.lstClassAttendance.length; i++) {
					var next = this.lstClassAttendance[i];

					next.SchoolStatusDesc = "School " + this.SchoolStatus;

					// if(this.SchoolStatus == "Closed"){
					//   next.ClassStatusID = -1;
					//   next.ExcuseID = -1;
					// }
				}

				this.loading = false;
			},
			(error) => {}
		);
	}

	LoadSchoolStatus() {
		var fDate = moment(this.SelectDate).format("MM/DD/YYYY");

		var result = this.classAdminService.SchoolOpen(this.SchoolID, fDate);
		result.subscribe(
			(response) => {
				this.SchoolStatus = response ? "Open" : "Closed";

				this.SchoolClosed = response ? false : true;

				this.LoadClassAttendance();
			},
			(error) => {}
		);
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////
	onAllPresent() {
		var PresentID = -1;

		for (var i = 0; i < this.AttendanceStatusList.length; i++) {
			var next = this.AttendanceStatusList[i];

			if (String(next.ClassAttendanceStatusDesc).toLowerCase().indexOf("present") != -1) {
				PresentID = next.ClassAttendanceStatusID;
				break;
			}
		}

		for (var i = 0; i < this.lstClassAttendance.length; i++) {
			var next = this.lstClassAttendance[i];

			next.ClassStatusID = PresentID;
			next.ExcuseID = -1;
		}
	}

	onAllAbsent() {
		var AbsentID = -1;

		for (var i = 0; i < this.AttendanceStatusList.length; i++) {
			var next = this.AttendanceStatusList[i];

			if (String(next.ClassAttendanceStatusDesc).toLowerCase().indexOf("absent from class") != -1) {
				AbsentID = next.ClassAttendanceStatusID;
				break;
			}
		}

		for (var i = 0; i < this.lstClassAttendance.length; i++) {
			var next = this.lstClassAttendance[i];

			next.ClassStatusID = AbsentID;
			next.ExcuseID = -1;
		}
	}

	onAdd() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		for (var i = 0; i < this.lstClassAttendance.length; i++) {
			var next = this.lstClassAttendance[i];

			if (next.ClassStatusID == -1) {
				this.errorMessage = "Some students are missing an attendance Status";
				return;
			}

			if (!this.ValidExcuse(next.ClassStatusID, next.ExcuseID)) {
				this.errorMessage = "Some students have an invalid excuse";
				return;
			}
		}

		//
		//Create Request Model
		//

		//Make a list of student infos
		let lstStudentInfos: StudentAttendanceInfo[] = [];

		for (var i = 0; i < this.lstClassAttendance.length; i++) {
			var next = this.lstClassAttendance[i];

			let nextInfo: StudentAttendanceInfo = {
				StudentID: next.StudentID,
				PersonID: next.PersonID,
				LastName: next.LastName,
				FirstName: next.FirstName,
				Active: next.Active,
				Advisor: next.Advisor,
				ClassStatusID: next.ClassStatusID,
				ExcuseID: next.ExcuseID,
				SectionScheduleID: next.SectionScheduleID,
				SectionScheduleDetailID: next.SectionScheduleDetailID,
				ClassAttendanceID: next.ClassAttendanceID,
				ClassAttendanceStudentID: next.ClassAttendanceStudentID,
			};

			lstStudentInfos = [...lstStudentInfos, nextInfo];
		}

		//Create request model
		let parms: ClassAttendanceRequestModel = {
			SectionID: this.SectionScheduleDetailID,
			EntryDate: moment(this.SelectDate).format("MM/DD/YYYY"),
			SchoolID: this.SchoolID,
			User_PersonID: this.user.PersonID,
			StudentInfos: lstStudentInfos,
		};

		//Call SP
		var result = this.classAdminService.AddClassAttendance(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Class Attendance Record added successfully",
						header: "Class Attendance",
						icon: "fa",
						accept: () => {
							this.Mode = "Update";
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Add Class Attendance Record",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onUpdate() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		for (var i = 0; i < this.lstClassAttendance.length; i++) {
			var next = this.lstClassAttendance[i];

			if (next.ClassStatusID == -1) {
				this.errorMessage = "Some students are missing an attendance Status";
				return;
			}

			if (!this.ValidExcuse(next.ClassStatusID, next.ExcuseID)) {
				this.errorMessage = "Some students have an invalid excuse";
				return;
			}
		}

		//
		//Create Request Model
		//

		//Make a list of student infos
		let lstStudentInfos: StudentAttendanceInfo[] = [];

		for (var i = 0; i < this.lstClassAttendance.length; i++) {
			var next = this.lstClassAttendance[i];

			let nextInfo: StudentAttendanceInfo = {
				StudentID: next.StudentID,
				PersonID: next.PersonID,
				LastName: next.LastName,
				FirstName: next.FirstName,
				Active: next.Active,
				Advisor: next.Advisor,
				ClassStatusID: next.ClassStatusID,
				ExcuseID: next.ExcuseID,
				SectionScheduleID: next.SectionScheduleID,
				SectionScheduleDetailID: next.SectionScheduleDetailID,
				ClassAttendanceID: next.ClassAttendanceID,
				ClassAttendanceStudentID: next.ClassAttendanceStudentID,
			};

			lstStudentInfos = [...lstStudentInfos, nextInfo];
		}

		//Create request model
		let parms: ClassAttendanceRequestModel = {
			SectionID: this.SectionScheduleDetailID,
			EntryDate: moment(this.SelectDate).format("MM/DD/YYYY"),
			SchoolID: this.SchoolID,
			User_PersonID: this.user.PersonID,
			StudentInfos: lstStudentInfos,
		};

		//Call SP
		var result = this.classAdminService.UpdateClassAttendance(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Class Attendance Record updated successfully",
						header: "Class Attendance",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Class Attendance Record",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedClassAttendance = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedClassAttendance = null;
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////

	// onStatusChange(newVal, ClassAttendance){
	//   ClassAttendance.ClassStatusID = newVal;

	//   var entry: any;
	//   for(var i = 0; i < this.AttendanceStatusList.length; i++){
	//     var next = this.AttendanceStatusList[i];

	//     if(next.ClassAttendanceStatusID == newVal){
	//       entry = next;
	//       break;
	//     }
	//   }

	//   if(entry.IsExcusedInd != 1 ||
	//     String(entry.ClassAttendanceStatusDesc).toLowerCase().indexOf('present') != -1){

	//     ClassAttendance.ExcuseID = -1;
	//   }

	// }

	ValidExcuse(ClassStatusID, ExcuseID) {
		var entry: any;
		for (var i = 0; i < this.AttendanceStatusList.length; i++) {
			var next = this.AttendanceStatusList[i];

			if (next.ClassAttendanceStatusID == ClassStatusID) {
				entry = next;
				break;
			}
		}

		if (entry == undefined) {
			return false;
		} else if (entry.IsExcusedInd == 1) {
			//Present doesn't need an excuse
			if (String(entry.ClassAttendanceStatusDesc).toLowerCase().indexOf("present") == -1) {
				return ExcuseID != -1 ? true : false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	}

	IsError() {
		if (this.lstClassAttendance.length == 0) {
			return false;
		} else {
			if (this.lstClassAttendance[0].RET == "") {
				return false;
			} else {
				return true;
			}
		}
	}

	IsExcused(StatusID, ClassAttendance) {
		var entry: any;

		for (var i = 0; i < this.AttendanceStatusList.length; i++) {
			var next = this.AttendanceStatusList[i];

			if (next.ClassAttendanceStatusID == StatusID) {
				entry = next;
				break;
			}
		}

		if (entry != undefined) {
			var ans = entry.IsExcusedInd == 1 ? true : false;

			if (ans == false) {
				ClassAttendance.ExcuseID = -1;
			}

			if (String(entry.ClassAttendanceStatusDesc).toLowerCase().indexOf("present") != -1) {
				return false; //Present shouldn't have an excuse?
			}

			return ans;
		} else {
			ClassAttendance.ExcuseID = -1;
			return false;
		}
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////

	FormatDate(d) {
		var ans = "Invalid Date";

		try {
			ans = moment(new Date(d)).format("dddd, MM/DD/YYYY");
		} catch (e) {
			console.log(e);
		}

		return ans;
	}

	/////////////////////////////////////////
}
